import { MinimumSegment } from '../../../domain/segments';

/** Segment paired with raw audio bytes for MediaSource playback. */
export type SegmentWithAudio = { segment: MinimumSegment; audio: ArrayBuffer };

export type SegmentWithSource = { segment: MinimumSegment; audioSrc: string };

export enum PlaybackTech {
  MEDIA_SOURCE = 'MEDIA_SOURCE',
  AUDIO_SRC = 'AUDIO_SRC',
}
